import { useForm } from '@mantine/form';
import { Button, Group, Stack, Textarea, TextInput } from '@mantine/core';
import React from 'react';

export interface MutateTagFormValues {
  name: string;
  description: string;
}

interface MutateTagFormProps {
  initialValues: MutateTagFormValues;
  onSubmit: (formValues: MutateTagFormValues) => void;
  onCancel?: () => void;
  isSubmitting?: boolean;
  submitButtonText: string;
  isUpdating?: boolean;
}

export default function MutateTagForm({
  initialValues,
  onSubmit,
  onCancel,
  isSubmitting,
  submitButtonText,
  isUpdating,
}: MutateTagFormProps) {
  const form = useForm<MutateTagFormValues>({
    mode: 'uncontrolled',
    initialValues: {
      name: initialValues.name,
      description: initialValues.description,
    },
    validate: {
      name: (value) => {
        if (!value.trim()) return ' ';
      },
    },
  });

  const handleSubmit = form.onSubmit((values) => {
    onSubmit(values);
  });

  const handleCancel = () => {
    form.reset();
    onCancel?.();
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Stack gap={'sm'}>
          {/* 標籤名稱 */}
          {!isUpdating && (
            <TextInput
              label={'標籤名稱'}
              placeholder={'請輸入標籤名稱'}
              withAsterisk
              key={form.key('name')}
              {...form.getInputProps('name')}
              styles={{
                label: { marginBottom: 8 },
                input: {
                  paddingLeft: 10,
                  borderColor: form.errors.name
                    ? 'var(--mantine-color-red-6)'
                    : undefined,
                },
              }}
            />
          )}

          {/* 標籤說明 */}
          <Textarea
            label={'標籤說明'}
            key={form.key('description')}
            {...form.getInputProps('description')}
            rows={4}
            styles={{
              label: { marginBottom: 8 },
              input: {
                paddingLeft: 10,
                borderColor: form.errors.description
                  ? 'var(--mantine-color-red-6)'
                  : undefined,
              },
            }}
          />
        </Stack>

        {/* 取消 與 新增 or 更新按鈕 */}
        <Group justify="flex-end" mt="md">
          <Button variant="outline" onClick={handleCancel}>
            取消
          </Button>
          <Button
            type="submit"
            loading={isSubmitting}
            loaderProps={{ type: 'oval', size: 'xs' }}
          >
            {submitButtonText}
          </Button>
        </Group>
      </form>
    </>
  );
}
